import {
  VehicleGroupSearchFormValues,
  VehicleGroupEditFormValues,
  VehicleGroupDetailFormValues,
  VehicleGroupVehiclesEditFormValues,
} from "./types";

/*-------------------------------------------------------------------------------------------
  CALCULATION SETTING - VEHICLE GROUP SEARCH
---------------------------------------------------------------------------------------------*/
export const initialVehicleGroupSearchForm: VehicleGroupSearchFormValues = {
  search: "",
};

/*-------------------------------------------------------------------------------------------
  CALCULATION SETTING - VEHICLE GROUP DETAIL
---------------------------------------------------------------------------------------------*/

export const initialVehicleGroupDetailForm: VehicleGroupDetailFormValues = {
  id: null,
  name: null,
  parentVehicleGroupId: null,
  parentVehicleGroupName: null,
};

/*-------------------------------------------------------------------------------------------
  CALCULATION SETTING - VEHICLE GROUP EDIT
---------------------------------------------------------------------------------------------*/

export const initialVehicleGroupEditForm: VehicleGroupEditFormValues = {
  name: null,
  parentVehicleGroupId: null,
};

/*-------------------------------------------------------------------------------------------
  CALCULATION SETTING - VEHICLE GROUP VEHICLES - EDIT
---------------------------------------------------------------------------------------------*/
export const initialVehicleGroupVehiclesEditFormValues: VehicleGroupVehiclesEditFormValues =
  {
    vehicleManufacturerId: "",
    vehicleModelId: null,
    vehicleTypeId: null,
  };
